export const hasBagsLoadedData = (bagList) => (bagList?.loadedCount ?? 0) > 0

export const bagStatusLabel = (bag, showLoadedStatus) => {
  if (showLoadedStatus) {
    if (bag?.loaded) return "Loaded"
    if (bag?.checkedIn) return "Not loaded (checked-in)"
    return "Not checked in"
  }
  if (bag?.checkedIn) return "Checked-in"
  return "Not checked in"
}
